module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "lis"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illustrations#lis"
    }
  }, [_vm._v("List of Illustrations and Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_vm._v("PART I"), _c('br'), _vm._v("A SCHOLAR’S STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("From Bible Belt to Bible Scholar")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("The Journey Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Creation in the Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("The Ancient Near East and the Beginnings of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Flood Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesopotamian Parallels")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("“After Its Kind”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genetics and Evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II"), _c('br'), _vm._v("EVANGELICALS AND EVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Shifting Conversation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Science and Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Science and Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Believing Scientist")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Genesis Reconsidered")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How We Got the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III"), _c('br'), _vm._v("ADAM AND HUMAN ANCESTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_c('i', [_vm._v("Homo neanderthalensis")]), _vm._v(", "), _c('i', [_vm._v("Homo denisova")]), _vm._v(", and "), _c('i', [_vm._v("Homo sapiens")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Ancestry")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Adam Debate")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Iconic Human")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("“In Our Image”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections of a Biblical Scholar")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scriptures")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0